import React from 'react';
import PropTypes from 'prop-types';
import { Button, Icon } from 'semantic-ui-react';

import CreditCheckScoreCTOS from './CreditCheckScoreCTOS';
import CreditCheckScoreDSR from './CreditCheckScoreDSR';

import Timestamp from './Timestamp';

const statusText = (status) => {
  let nodeText;
  switch (status) {
    case 'request_ctos_bad_request':
      nodeText = (
        <div>
          <h2>Report not available</h2>
          <p>currently does not have credit  report with CTOS.</p>
          <p style={{ marginBottom: '.1em' }}>How do we resolve this?</p>
          <div>
            <ul style={{ listStylePosition: 'inside' }}>
              <li>
                Check IC Number validity
              </li>
              <li>
                Make sure name matches IC
              </li>
            </ul>
          </div>
        </div>);
      break;
    case 'request_ctos_muliple_entities':
      nodeText = (
        <div>
          <h2>Multiple entities</h2>
          <p>Currently have multiple entities with CTOS.</p>
          <p style={{ marginBottom: '.1em' }}>How do we resolve this?</p>
          <div>
            <ul style={{ listStylePosition: 'inside' }}>
              <li>
                Please contact admin for more info
              </li>
            </ul>
          </div>
        </div>);
      break;
    default:
      nodeText = (
        <div>
          <h2>Pending Request</h2>
          <p>Please check again later.</p>
        </div>);
  }
  return nodeText;
};

const CreditCheckScores = ({
  allowBranchLeaderDownload,
  allowStaffDownload,
  allowAgentDownload,
  auth,
  mCtosHTMLStatusID,
  mCtosXMLStatusID,
  currentLoanAmount,
  dsr,
  dsrScoreAfter,
  ctosScore,
  createdAt,
  editClick,
  openHTML,
  netIncome,
}) => (
  <div className="credit-check-scores">
    {
      mCtosXMLStatusID === 'dsr_generated' && (
        <p
          className="clear"
          style={{
            marginBottom: '1em',
            fontSize: '1.2em',
          }}
        >
          Generated on <Timestamp timestamp={createdAt} />
        </p>
      )
    }
    <div className="scores clear">
      <CreditCheckScoreCTOS
        ctosScore={ctosScore}
        mCtosXMLStatusID={mCtosXMLStatusID}
      />
      <CreditCheckScoreDSR
        dsr={dsr}
        dsrScoreAfter={dsrScoreAfter}
        currentLoanAmount={currentLoanAmount}
        mCtosXMLStatusID={mCtosXMLStatusID}
        netIncome={netIncome}
      />
    </div>
    {
      mCtosXMLStatusID !== 'dsr_generated' ?
        <div className="status text-center">
          {statusText(mCtosXMLStatusID)}
        </div> :
        <div className="status text-center">
          <Button
            onClick={editClick}
            size="small"
            color="blue"
          >
            <Icon name="pencil" />Edit Income
          </Button>
          {
            mCtosHTMLStatusID === 'request_success' && auth && (
            auth.isSuperAdmin ||
            auth.isHeadquarters ||
            (auth.isBranchLeader && allowBranchLeaderDownload) ||
            (auth.isDeveloperStaff && allowStaffDownload) ||
            ((auth.isExternalAgentLeader || auth.isExternalAgent || auth.isExternalAgencyAdmin) && allowAgentDownload)) ?
              <Button
                onClick={openHTML}
                size="small"
                color="blue"
              >
                HTML Report
              </Button> : null
          }
        </div>
    }
  </div>
);

CreditCheckScores.propTypes = {
  allowBranchLeaderDownload: PropTypes.bool,
  allowAgentDownload: PropTypes.bool,
  allowStaffDownload: PropTypes.bool,
  auth: PropTypes.shape({
    isBranchLeader: PropTypes.bool,
    isHeadquarters: PropTypes.bool,
    isSuperAdmin: PropTypes.bool,
    isDeveloperStaff: PropTypes.bool,
    isExternalAgentLeader: PropTypes.bool,
    isExternalAgent: PropTypes.bool,
    isExternalAgencyAdmin: PropTypes.bool,
  }),
  mCtosHTMLStatusID: PropTypes.string,
  mCtosXMLStatusID: PropTypes.string,
  currentLoanAmount: PropTypes.number,
  dsr: PropTypes.number,
  dsrScoreAfter: PropTypes.number,
  ctosScore: PropTypes.string,
  createdAt: PropTypes.string,
  editClick: PropTypes.func,
  openHTML: PropTypes.func,
  netIncome: PropTypes.number,
};

CreditCheckScores.defaultProps = {
  mCtosXMLStatusID: 'new',
  dsr: 0,
  ctosScore: null,
  auth: null,
};

export default CreditCheckScores;



// WEBPACK FOOTER //
// ./src/components/CreditCheckScores.jsx